.container {
    display: flex;
    flex-direction: column;
    gap: 48px;
    margin-bottom: 64px;
    width: 100%;
}

.hero-card {
    background-color: #edf7fe;
    border-radius: 12px;
    padding: 80px;
    box-sizing: border-box;

    img {
        width: 30%;
        max-height: 200px;
    }
}

.trial-heading span {
    font-size: 32px;
    line-height: 40px;
}

.active-layout {
    display: flex;
    flex-direction: row;
    gap: 32px;
    align-items: center;
    width: 100%;
}

.expired-layout {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
}

.expired-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    text-align: center;
    max-width: 500px;
}

.bullet-grids {
    display: flex;
    flex-direction: row;
    gap: 24px;
}

.bullet-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.add-ons-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.add-ons-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

@media (max-width: 1350px) {
    .add-ons-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
